<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'sample-prebuiltSampleNo',
  components: {
    PageTable,
  },
}
</script>
